
<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">menu</mat-icon>
				<span>Spartenverwaltung</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bLoading"></mat-spinner>

			<button
				mat-raised-button
				color="primary"
				[disabled]="bLoading"
				(click)="showCreationDialog()"
			>
				Neue Sparte
			</button>

		</div>

		<div>

			@if( bLoading ) {
				<!-- there is already a spinner higher -->			
			}
			@else if( !elements.length ) {
				<div class="accNoElements">
					Keine Sparten vorhanden
				</div>
			}
			@else {

				<div class="accFilterAndAccordeon">

					<mat-form-field
						appearance="outline"
						subscriptSizing="dynamic"
						class="accFilter"
					>

						<mat-label>Filter</mat-label>
						<input
							matInput
							placeholder="Beispiel: sparte2020"
							(keyup)="onFilterChanged($event)"
						>
						<mat-icon matSuffix>search</mat-icon>

					</mat-form-field>

					<div
						class="accAccordeon"
						[style.--nbColumns]="'2'"
					>
	
						@if( !filteredElements.length ) {
	
							<div class="accNoElements">
								Keine Daten entspricht dem Filter
							</div>
	
						}	
						@else {

							<div
								class="accHeaders"
								[class.accSortIconDesc]="!sortingAsc"
							>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'sparteBezeichnung'"
									(click)="sortColumn('sparteBezeichnung')"
									title="Nach Bezeichnung sortieren"
								>
									<div class="accHeader">
										<span>Bezeichnung</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'sparteBezeichnung' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'sparteBeshreibung'"
									(click)="sortColumn('sparteBeshreibung')"
									title="Nach Beschreibung sortieren"
								>
									<div class="accHeader">
										<span>Beschreibung</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'sparteBeshreibung' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>
	
							</div>
								
							<div class="accScrollPanel">
	
								@for( element of filteredElements; track element.sparteId ) {
	
									<div
										class="accRow"
										(click)="clickOnRow( element.sparteId )"
										[class.accRowActive]="expandedElementId == element.sparteId"
										[id]="'elementRow_' + element.sparteId"
									>
										<div class="accCell">
											{{ element.sparteBezeichnung }}
										</div>
										<div class="accCell">
											{{ element.sparteBeshreibung }}
										</div>
									</div>
	
									@if( expandedElementId == element.sparteId ) {
	
										<div
											class="accDetail"
											[@accordeonMe]
										>
											<app-section-editor [section]="element" />
										</div>
	
									}
	
								}
	
							</div>
	
						}
	
					</div>

				</div>

			}

		</div>

	</div>

</div>